import React from 'react';
import Icon from '../../../components/AppIcon';

const steps = [
  {
    icon: 'Clock',
    title: 'Professional Reviews Your Request',
    description: 'The professional will review your consultation request and respond within 24 hours.',
    timeframe: 'Within 24 hours',
    color: '#00D4FF'
  },
  {
    icon: 'MessageCircle',
    title: 'Confirmation & Scheduling',
    description: 'You will receive a confirmation email with the confirmed date, time, and meeting details.',
    timeframe: 'After review',
    color: '#00FF88'
  },
  {
    icon: 'Video',
    title: 'Consultation Meeting',
    description: 'Join your consultation via phone, video call, or in-person as agreed with the professional.',
    timeframe: 'On scheduled date',
    color: '#FFD700'
  }
];

const preparationTips = [
  'Gather all relevant property documents and contracts',
  'Prepare a list of specific questions you want answered',
  'Have your budget and timeline information ready',
  'Note any concerns or issues you want to discuss'
];

const NextStepsSection = () => {
  return (
    <div className="space-y-6">
      {/* Timeline Steps */}
      <div className="rounded-2xl p-6" style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(0,212,255,0.15)' }}>
        <h2 className="text-lg font-bold text-white mb-5 flex items-center gap-2">
          <Icon name="ListChecks" size={20} color="#00D4FF" />
          What Happens Next
        </h2>
        <div className="space-y-0">
          {steps?.map((step, index) => (
            <div key={index} className="flex gap-4">
              <div className="flex flex-col items-center">
                <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: `rgba(${step?.color === '#00D4FF' ? '0,212,255' : step?.color === '#00FF88' ? '0,255,136' : '255,215,0'},0.15)`, border: `1px solid ${step?.color}40` }}>
                  <Icon name={step?.icon} size={18} color={step?.color} />
                </div>
                {index < steps?.length - 1 && (
                  <div className="w-0.5 h-8 my-1" style={{ background: 'rgba(0,212,255,0.15)' }} />
                )}
              </div>
              <div className="pb-6">
                <div className="flex items-center gap-2 mb-1">
                  <p className="text-sm font-bold text-white">{step?.title}</p>
                  <span className="px-2 py-0.5 rounded-full text-xs" style={{ background: `rgba(${step?.color === '#00D4FF' ? '0,212,255' : step?.color === '#00FF88' ? '0,255,136' : '255,215,0'},0.1)`, color: step?.color }}>
                    {step?.timeframe}
                  </span>
                </div>
                <p className="text-sm" style={{ color: '#A0B4C8' }}>{step?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Preparation Tips */}
      <div className="rounded-2xl p-6" style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(0,212,255,0.15)' }}>
        <h2 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
          <Icon name="Lightbulb" size={20} color="#FFD700" />
          Consultation Preparation Tips
        </h2>
        <div className="space-y-3">
          {preparationTips?.map((tip, index) => (
            <div key={index} className="flex items-start gap-3">
              <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: 'rgba(0,255,136,0.15)' }}>
                <Icon name="Check" size={11} color="#00FF88" />
              </div>
              <p className="text-sm" style={{ color: '#A0B4C8' }}>{tip}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NextStepsSection;
